import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import BaseBackground from '../../../domain/entities/BaseBackground';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexBaseBackgroundsSuccess: {
      const result = action.payload as PaginatedResult<BaseBackground>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
